import { render, staticRenderFns } from "./worksList.vue?vue&type=template&id=4372cbfe&scoped=true&"
import script from "./worksList.vue?vue&type=script&lang=js&"
export * from "./worksList.vue?vue&type=script&lang=js&"
import style0 from "./worksList.vue?vue&type=style&index=0&id=4372cbfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4372cbfe",
  null
  
)

export default component.exports